import { setValue, clearValue } from '../../../utilities/local_storage';
import API from '../../../API/api';
import { getMap } from '../gmap';
import MapActions from '../../actions/map_actions';

export const setPostcodeV2 = async (postcode, setLatlng = false) => {
    try {
        let response;
        if (postcode) {
            response = await API.PUT({
                apiPath: '/api/v2/customers/addresses/default/',
                data: JSON.stringify({ autoSuggestLabel: postcode }),
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
            });
            const latLng = {
                lat: response.latitude,
                lng: response.longitude
            }
            if (latLng && typeof latLng.lat !== 'undefined' && typeof latLng.lng !== 'undefined') {
                if (setLatlng) {
                    const newLocation = getMap().formatLocation(latLng.lat, latLng.lng);
                    MapActions.setLatLngAction(newLocation);
                }
            }
            setValue('shippingPostcode', postcode);
            setValue('shippingState', response.state);
            setValue('latLng', latLng);
            setValue('bust', true);
        }
        return Promise.resolve(response);
    } catch (error) {
        clearValue('shippingPostcode');
        clearValue('shippingState');
        clearValue('latLng');
        console.log(error);
        return Promise.reject(error);
    }

};

export const setPostcodeV3 = async ({ latitude, longitude }) => {
    try {
        let response;
        if (latitude && longitude) {
            response = await API.PUT({
                apiPath: '/api/v2/customers/addresses/default/geolocation/',
                data: JSON.stringify({ latitude, longitude }),
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
            });
            const postcode = `${response.postcode}, ${(response.suburb || response.city)}`;
            const latLng = {
                lat: response.latitude,
                lng: response.longitude
            }
            setValue('shippingPostcode', postcode);
            setValue('shippingState', response.state);
            setValue('latLng', latLng);
            setValue('bust', true);
        }
        return Promise.resolve(response);
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }

};

export const getPostcodeV2 = async () => {
    try {
        const response = await API.GET({
            apiPath: '/api/v2/customers/addresses/default/',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
        });
        if (response && Object.prototype.hasOwnProperty.call(response, 'autoSuggestLabel')) {
            const latLng = {
                lat: response.latitude,
                lng: response.longitude
            }
            setValue('shippingPostcode', response.autoSuggestLabel);
            setValue('shippingState', response.state);
            setValue('latLng', latLng);
        }
        setValue('bust', true);
        return Promise.resolve(response);
    } catch (error) {
        console.log(error);
        return Promise.reject(error);

    }

};